// Filters

export const FILTER_PAGE = '_page_id'
export const FILTER_STATUS = '_status'
export const FILTER_TYPE = '_type'
export const FILTER_PRIORITY = '_priority'
export const FILTER_EPIC = '_epic'
export const FILTER_SPRINT = '_sprint'
export const FILTER_USER = '_user'
export const FILTER_STRATEGY_USER = '_strategyUser'

export const SELECT_OPTION_DEFAULT = ''
